import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":_vm.$t('Height'),"hide-details":"auto","outlined":"","type":"number"},model:{value:(_vm.height),callback:function ($$v) {_vm.height=_vm._n($$v)},expression:"height"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }